/**
 * Tiny invalidation signal: mutations call `invalidate()` so every mounted
 * query refetches from the API (the database is the source of truth).
 */
let revision = 0;
const listeners = new Set<() => void>();

export const dataRevision = {
  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  get: (): number => revision,
};

export function invalidate(): void {
  revision += 1;
  listeners.forEach((l) => l());
}
